document.documentElement.classList.remove('no-js');
(function(){
  const toggle=document.querySelector('[data-menu-toggle]');
  const menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;document.body.classList.toggle('menu-open',!open);});}
  document.querySelectorAll('[data-variant-select]').forEach(select=>{select.addEventListener('change',()=>{const opt=select.options[select.selectedIndex];const price=document.querySelector('[data-product-price]');if(price&&opt.dataset.price){price.innerHTML=opt.dataset.price+' <small>/ CASE</small>';}});});
})();

// Pure Exotics: inline case quantity + AJAX add-to-cart.
// Customers stay on the current page after adding products.
(function () {
  function clampQuantity(input) {
    var value = parseInt(input.value, 10);
    var min = parseInt(input.min || '1', 10);
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : null;

    if (!Number.isFinite(value) || value < min) value = min;
    if (Number.isFinite(max) && value > max) value = max;

    input.value = value;
    updateQtyButtons(input);
    return value;
  }

  function updateQtyButtons(input) {
    var wrap = input.closest('[data-qty-control]');
    if (!wrap) return;

    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min || '1', 10);
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : null;

    if (minus) minus.disabled = value <= min;
    if (plus) plus.disabled = Number.isFinite(max) && value >= max;
  }

  function updateCartCount(count) {
    var cartIcon = document.querySelector('.cart-icon');
    if (!cartIcon) return;

    var badge = cartIcon.querySelector('.cart-count');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        cartIcon.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  async function refreshCartCount() {
    try {
      var response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      var cart = await response.json();
      updateCartCount(cart.item_count || 0);
    } catch (error) {
      // Cart still updated server-side even if badge refresh fails.
    }
  }

  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var wrap = event.target.closest('[data-qty-control]');
    if (!wrap) return;

    var input = wrap.querySelector('.quick-add-qty__input');
    if (!input) return;

    var value = parseInt(input.value, 10) || 1;
    input.value = minus ? value - 1 : value + 1;
    clampQuantity(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('.quick-add-qty__input')) return;
    clampQuantity(event.target);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.quick-add-qty__input')) return;
    clampQuantity(event.target);
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('.quick-add-form');
    if (!form) return;

    event.preventDefault();

    var input = form.querySelector('.quick-add-qty__input');
    var quantity = input ? clampQuantity(input) : 1;
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-quick-add-button]');
    var label = form.querySelector('[data-quick-add-label]');
    var status = form.querySelector('[data-quick-add-status]');

    if (!idInput || !button) return;

    var originalLabel = label ? label.textContent : 'ADD TO CART';
    button.disabled = true;
    form.classList.add('is-adding');
    if (label) label.textContent = 'ADDING…';
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error', 'is-success');
    }

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: Number(idInput.value),
            quantity: quantity
          }]
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || 'Unable to add this item.');
      }

      await refreshCartCount();

      if (label) label.textContent = 'ADDED ✓';
      if (status) {
        status.textContent = quantity + ' case' + (quantity === 1 ? '' : 's') + ' added to cart.';
        status.classList.add('is-success');
      }

      // Keep the shopper on the same collection/home page.
      window.setTimeout(function () {
        if (label) label.textContent = originalLabel;
        if (status) status.textContent = '';
      }, 2200);
    } catch (error) {
      if (label) label.textContent = 'TRY AGAIN';
      if (status) {
        status.textContent = error.message || 'Unable to add this item.';
        status.classList.add('is-error');
      }

      window.setTimeout(function () {
        if (label) label.textContent = originalLabel;
      }, 2500);
    } finally {
      button.disabled = false;
      form.classList.remove('is-adding');
      if (input) updateQtyButtons(input);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quick-add-qty__input').forEach(function (input) {
      clampQuantity(input);
    });
  });
})();

